import * as React from 'react'

export function SummarySection({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section className="rounded-md border border-border bg-card p-4">
      <h2 className="text-body font-semibold text-foreground">{title}</h2>
      <dl className="mt-3 grid gap-2 text-body-sm">{children}</dl>
    </section>
  )
}

export function SummaryRow({ label, value }: { label: string; value: React.ReactNode }) {
  return (
    <div className="grid grid-cols-[10rem_1fr] gap-3">
      <dt className="text-muted-foreground">{label}</dt>
      <dd className="text-foreground">{value}</dd>
    </div>
  )
}
